export const Hamburger = () => {
    const hamburger = document.querySelector('.header__hamburger');
    const header = document.querySelector('.header');
    const tile = document.querySelector('.tile');
    if (!hamburger || !header) return;
    let scrollPos = 0;

    hamburger.addEventListener('click', () => {
        const isOpening = !hamburger.classList.contains('is-active');

        hamburger.classList.toggle('is-active');
        header.classList.toggle('is-nav-open');
        if (tile) tile.classList.toggle('tile--active');

        // Manage scroll lock when tile/menu opens
        if (isOpening) {
            scrollPos = window.scrollY || document.documentElement.scrollTop || 0;
            document.body.classList.add('no-scroll');
            document.body.style.top = `-${scrollPos}px`;
            document.body.style.left = '0';
            document.body.style.right = '0';
            document.body.style.position = 'fixed';
        } else {
            document.body.classList.remove('no-scroll');
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.left = '';
            document.body.style.right = '';
            window.scrollTo(0, scrollPos);
        }

        const expanded = hamburger.getAttribute('aria-expanded') === 'true';
        hamburger.setAttribute('aria-expanded', String(!expanded));
    });
};